import ModalDeleteBatchInvoice from './ModalDeleteBatchInvoice';

export default ModalDeleteBatchInvoice;
